/// <amd-module name="VSS/Features/Accounts/Components/AccountPickList" />
import * as React from "react";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { AccountPickerProvider } from "../AccountPickerProvider";
import { IAccountPickList, IAccountPickListProps } from "./AccountPickList.Props";

import { IPickList, ItemPickList } from "VSSUI/PickList";
import { css } from "VSSUI/Util";

export class AccountPickList extends VssComponent<IAccountPickListProps, {}> implements IAccountPickList {

    private pickerProvider: AccountPickerProvider;
    public pickList: IPickList | undefined;

    public constructor(props: IAccountPickListProps, context: IVssComponentContext) {
        super(props, context);

        this.pickerProvider = new AccountPickerProvider(context.pageContext, props.providerOptions);
    }

    public render(): JSX.Element | null {
        const { className, tabIndex, useDropdownStyle } = this.props;

        return (
            <ItemPickList
                provider={this.pickerProvider}
                className={css("account-picker", className)}
                useDropdownStyle={useDropdownStyle}
                componentRef={itemPicker => (this.pickList = itemPicker ? itemPicker.pickList : undefined)}
            />
        );
    }

    public componentDidMount(): void {
        super.componentDidMount();

        if (this.props.componentRef) {
            this.props.componentRef(this);
        }
    }

    public UNSAFE_componentWillReceiveProps(nextProps: IAccountPickListProps): void {
        if (nextProps.providerOptions !== this.props.providerOptions) {
            this.pickerProvider = new AccountPickerProvider(this.context.pageContext, nextProps.providerOptions);
        }
    }
}
